import DataLayerEnum from "../enumerators/data-layer.enum"

export default class DataLayerAction {
    constructor() {
        DataLayerAction.dataLayerCard()
    }

    static dataLayerCard() {
        $(DataLayerEnum.CARD).on("click", function () {
            dataLayer.push({
                event: "click_card",
                cardTitle: $(this).find(DataLayerEnum.CARD_TITLE).text().trim(),
            })
        })
    }
}
